/* Cloud Slides listicle advertorial — sticky hero CTA + announce-bar countdown + lazy video, isolated to this page's markup only. */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown() {
    var root = document.querySelector('[data-cloudslideslisticle-countdown]');
    if (!root) return;

    var hoursEl = root.querySelector('[data-cloudslideslisticle-unit="hours"]');
    var minutesEl = root.querySelector('[data-cloudslideslisticle-unit="minutes"]');
    var secondsEl = root.querySelector('[data-cloudslideslisticle-unit="seconds"]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    var durationHours = parseFloat(root.dataset.cloudslideslisticleCountdownHours) || 8;
    var durationMs = durationHours * 60 * 60 * 1000;
    var storageKey = 'cls-cloudslideslisticle-countdown-deadline';

    var deadline = null;
    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored) deadline = parseInt(stored, 10);
    } catch (e) {
      deadline = null;
    }

    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + durationMs;
      try {
        window.sessionStorage.setItem(storageKey, String(deadline));
      } catch (e) {
        /* private browsing / storage disabled — timer still runs in memory for this page view */
      }
    }

    function tick() {
      var remainingMs = deadline - Date.now();

      if (remainingMs <= 0) {
        deadline = Date.now() + durationMs;
        try {
          window.sessionStorage.setItem(storageKey, String(deadline));
        } catch (e) {
          /* ignore */
        }
        remainingMs = durationMs;
      }

      var totalSeconds = Math.floor(remainingMs / 1000);
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;

      hoursEl.textContent = pad(h);
      minutesEl.textContent = pad(m);
      secondsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initStickyCta() {
    var sentinel = document.querySelector('[data-cloudslideslisticle-sticky-trigger]');
    var stickyBar = document.querySelector('[data-cloudslideslisticle-sticky-bar]');
    if (!sentinel || !stickyBar || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var pastTrigger = entries[0].boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-active', pastTrigger);
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
  }

  function initLazyVideos() {
    var videos = document.querySelectorAll('[data-cloudslideslisticle-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        loadVideo(video);
        video.play().catch(function () {});
      });
      return;
    }

    function loadVideo(video) {
      if (video.dataset.loaded === 'true') return;
      var sources = video.querySelectorAll('source[data-src]');
      sources.forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      video.dataset.loaded = 'true';
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            loadVideo(video);
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '300px 0px' }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function init() {
    initCountdown();
    initStickyCta();
    initLazyVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
